import {
  Box, Button, Flex, Heading,
} from '@chakra-ui/react';
import { animated as a, useSpring } from 'react-spring';

import { BsChevronDown } from 'react-icons/bs';
import { Link } from 'gatsby';
import React from 'react';
import { generate } from 'shortid';

const MainNav = ({
  styles,
  show,
  setShow,
  ROUTES,
  setIsShown,
  isShown,
  showOffer,
}) => (
  <a.div
    style={{
      ...styles,
    }}
  >
    <Box
      display={showOffer ? 'none' : 'flex'}
      alignItems="center"
      overflow="hidden"
      width={{ base: '0px', lg: 'auto' }}
    >
      {ROUTES.map((r) => (
        <Box
          className={`link-one light ${false ? 'active' : ''}`}
          pr={4}
          fontWeight="bold"
          onClick={() => setShow(false)}
          key={`route${r.id}`}
        >
          <Link to={`${r.to}`}>{r.name}</Link>
        </Box>
      ))}
      <Box
        onClick={() => {
          setShow(false);
          setIsShown(!isShown);
        }}
        as="button"
        pr={4}
        py={4}
        fontWeight="bold"
        display="flex"
        alignItems="center"
      >
        Our Company&nbsp;
        <BsChevronDown />
      </Box>
      <Link to="/get-offer/#get-offer-form">
        <Button variant="btnCTA">Get your offer</Button>
      </Link>
    </Box>
  </a.div>
);

export default MainNav;
